import { createAccessControl } from 'better-auth/plugins/access';
import {
  adminAc,
  defaultStatements,
  userAc,
} from 'better-auth/plugins/admin/access';

export const ac = createAccessControl(defaultStatements);

/**
 * Roles answer "who is this person". Complimentary access is not a role: it
 * is a billing grant on `user_billing` (`comp_granted_at`), written by
 * `apps/api/scripts/make-comp.ts`, so an admin can be comped and a comp can be
 * revoked without touching permissions.
 */
export const roles = {
  admin: adminAc,
  user: userAc,
};
